(function(){
  /* ---- Blocage du scroll de fond quand le panier est ouvert (iOS-safe) ---- */
  var __sy=0, __locked=false;
  function lock(){if(__locked)return;__locked=true;__sy=window.scrollY||window.pageYOffset||0;document.documentElement.classList.add('kinbo-cart-open');var b=document.body;b.style.position='fixed';b.style.top=(-__sy)+'px';b.style.left='0';b.style.right='0';b.style.width='100%';b.style.overflow='hidden';}
  function unlock(){if(!__locked)return;__locked=false;document.documentElement.classList.remove('kinbo-cart-open');var b=document.body;b.style.position='';b.style.top='';b.style.left='';b.style.right='';b.style.width='';b.style.overflow='';window.scrollTo(0,__sy);}
  function __isOpen(){var d=document.getElementById('cart-drawer');if(!d)return false;var r=d.style.right;return r==='0'||r==='0px';}
  function __syncLock(){if(__isOpen())lock();else unlock();}
  function __watchLock(){var d=document.getElementById('cart-drawer');if(!d||d.__slObs)return;d.__slObs=true;try{new MutationObserver(__syncLock).observe(d,{attributes:true,attributeFilter:['style','class']});}catch(e){}__syncLock();}
  function __touchGuard(){if(window.__kinboTouchGuard)return;window.__kinboTouchGuard=true;document.addEventListener('touchmove',function(e){if(!__locked)return;var t=e.target;var sc=(t&&t.closest)?t.closest('.cart-drawer__scroll'):null;if(!sc)e.preventDefault();},{passive:false});}
  function killAnims(){var d=document.getElementById('cart-drawer');if(d&&d.getAnimations){try{d.getAnimations().forEach(function(a){a.cancel();});}catch(e){}}}
  function forceRight(){var d=document.getElementById('cart-drawer');if(d)d.style.right='0';}
  function wrapOpen(){var o=window.openCartDrawer;if(typeof o==='function'&&!o.__lockWrapped){var nf=function(){killAnims();var r=o.apply(this,arguments);killAnims();forceRight();lock();return r;};nf.__lockWrapped=true;window.openCartDrawer=nf;}}
  function wrapClose(){var o=window.closeCartDrawer;if(typeof o==='function'&&!o.__lockWrapped){var nf=function(){var r=o.apply(this,arguments);unlock();return r;};nf.__lockWrapped=true;window.closeCartDrawer=nf;}}

  /* ---- Confettis quand la livraison gratuite est debloquee ---- */
  var __cfDone=false;
  function confetti(){
    if(__cfDone)return;__cfDone=true;
    var host=document.getElementById('cart-drawer')||document.body;
    var colors=['#111','#16a34a','#e8b923','#ffffff','#888'];
    for(var i=0;i<42;i++){
      var d=document.createElement('div');
      var size=6+(i%3)*2;
      d.style.cssText='position:absolute;top:64px;left:'+(8+(i*7)%84)+'%;width:'+size+'px;height:'+size+'px;background:'+colors[i%colors.length]+';border-radius:2px;z-index:10001;pointer-events:none;opacity:1;transform:translateY(0) rotate(0deg);transition:transform 1.1s ease-out,opacity 1.1s ease-out;';
      host.appendChild(d);
      (function(el,idx){setTimeout(function(){el.style.transform='translateY('+(220+(idx%5)*40)+'px) rotate('+(160+idx*20)+'deg)';el.style.opacity='0';},20);setTimeout(function(){if(el.parentNode)el.parentNode.removeChild(el);},1300);})(d,i);
    }
  }
  function watchBar(){
    var bar=document.getElementById('cart-shipping-bar');if(!bar||bar.__cfObs)return;bar.__cfObs=true;
    var mo=new MutationObserver(function(){
      if(bar.querySelector('.shipping-bar--reached')){confetti();}else{__cfDone=false;}
    });
    mo.observe(bar,{childList:true,subtree:true});
  }

  /* ---- Post-rendu : total sur le bouton, poubelle -> "Supprimer", panier vide ---- */
  function mirrorTotal(){
    var dt=document.getElementById('cart-drawer-total');if(!dt||dt.__mir)return;dt.__mir=true;
    function cp(){var ct=document.getElementById('cart-checkout-total');if(ct)ct.textContent=dt.textContent;}
    new MutationObserver(cp).observe(dt,{childList:true,characterData:true,subtree:true});
    cp();
  }
  function hideAloDoublon(){
    var items=document.getElementById('cart-drawer-items');if(!items)return;
    var kids=items.children;
    for(var i=0;i<kids.length;i++){var k=kids[i];if(k.nodeType===1&&k.textContent&&k.textContent.indexOf("d'achats Alo")!==-1){k.style.display='none';}}
  }
  function fixBins(){
    var items=document.getElementById('cart-drawer-items');if(!items)return;
    items.querySelectorAll('img').forEach(function(im){
      var s=im.getAttribute('src')||'';
      if(s.indexOf('bin.png')===-1)return;
      var svg='<svg class="kinbo-bin-svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" style="color:#9a9a9a"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>';
      im.insertAdjacentHTML('afterend',svg);
      if(im.parentNode)im.parentNode.removeChild(im);
    });
  }
  function watchItems(){
    var items=document.getElementById('cart-drawer-items');if(!items||items.__aloObs)return;items.__aloObs=true;
    new MutationObserver(function(){hideAloDoublon();fixBins();}).observe(items,{childList:true});
    hideAloDoublon();fixBins();
  }
  function postRender(){
    var pur=document.getElementById('cart-purchase');if(pur)pur.style.display='block';
    var dt=document.getElementById('cart-drawer-total'),ct=document.getElementById('cart-checkout-total');
    if(ct&&dt)ct.textContent=dt.textContent;
    watchItems();hideAloDoublon();fixBins();
  }
  function wrapRender(){var o=window.loadCart;if(typeof o==='function'&&!o.__prWrapped){var nf=function(){var r=o.apply(this,arguments);setTimeout(postRender,120);setTimeout(postRender,420);return r;};nf.__prWrapped=true;window.loadCart=nf;}}

  function init(){wrapOpen();wrapClose();wrapRender();watchBar();mirrorTotal();postRender();__watchLock();__touchGuard();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

(function(){
  /* ---- Ouvre notre panier a chaque ajout (page produit, quick add, etc.) ---- */
  if(window.__kinboAddHook)return; window.__kinboAddHook=true;
  var of=window.fetch;
  if(typeof of!=='function')return;
  window.fetch=function(){
    var a0=arguments[0];
    var u=(a0&&a0.url)?a0.url:a0;
    var isAdd=(typeof u==='string') && u.indexOf('/cart/add')!==-1;
    var pr=of.apply(this,arguments);
    if(isAdd&&pr&&pr.then){
      pr.then(function(res){
        if(res&&res.ok===false)return;
        setTimeout(function(){
          if(window.loadCart)window.loadCart();
          var d=document.getElementById('cart-drawer');
          if(d&&window.openCartDrawer&&getComputedStyle(d).right!=='0px'){window.openCartDrawer();}
        },180);
      }).catch(function(){});
    }
    return pr;
  };
})();

(function(){
  /* ---- Loupe de recherche a GAUCHE, a cote du burger (logo centre) ---- */
  function addSearch(){
    var inner=document.querySelector('.site-header__inner');
    var burger=document.querySelector('.site-header__hamburger');
    if(!inner||!burger||document.getElementById('kinbo-search-ico'))return;
    var a=document.createElement('a');
    a.id='kinbo-search-ico';
    a.href='/search';
    a.className='site-header__icon-btn site-header__search';
    a.setAttribute('aria-label','Rechercher');
    a.innerHTML='<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>';
    var left=document.querySelector('.site-header__left');
    if(!left){
      left=document.createElement('div');
      left.className='site-header__left';
      inner.insertBefore(left, inner.firstChild);
      left.appendChild(burger);
    }
    left.appendChild(a);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',addSearch);}else{addSearch();}
})();

(function(){
  /* ---- Header transparent sur le hero (home only) + solidification au scroll ---- */
  if(location.pathname!=='/')return;
  var html=document.documentElement;
  html.classList.add('kinbo-home-thdr');
  function onScroll(){var y=window.scrollY||window.pageYOffset||0;if(y>80){html.classList.add('kinbo-scrolled');}else{html.classList.remove('kinbo-scrolled');}}
  onScroll();
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});
})();

(function(){
  /* ---- Icone panier nette : remplace le PNG pixelise par un SVG sac (ligne) coherent ---- */
  function fixCart(){
    var cart=document.querySelector('.site-header__cart');
    if(!cart||cart.__iconFixed)return;
    var img=cart.querySelector('img');
    if(!img)return;
    cart.__iconFixed=true;
    var svg='<svg class="kinbo-cart-svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg>';
    img.insertAdjacentHTML('afterend',svg);
    img.parentNode.removeChild(img);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fixCart);}else{fixCart();}
})();

(function(){
  /* ---- Icones premium (reassurance, timeline, engagements) : SVG nets et coherents ---- */
  var A='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">';
  var SHIELD=A+'<path d="M12 22s7-3.5 7-9V5.5L12 3 5 5.5V13c0 5.5 7 9 7 9z"></path><path d="M9 12l2 2 4-4"></path></svg>';
  var TRUCK=A+'<path d="M3 6.5h11v9H3z"></path><path d="M14 9.5h3.5L21 13v2.5h-7z"></path><circle cx="7" cy="18" r="1.7"></circle><circle cx="17.5" cy="18" r="1.7"></circle></svg>';
  var RETURN=A+'<polyline points="3 4 3 10 9 10"></polyline><path d="M4 14a8 8 0 1 0 2-8.5L3 10"></path></svg>';
  var BAG=A+'<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg>';
  var GIFT=A+'<polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg>';
  function setTrio(nodes,a,b,c){ if(nodes&&nodes.length>=3){nodes[0].innerHTML=a;nodes[1].innerHTML=b;nodes[2].innerHTML=c;} }
  function fixSectionIcons(){
    setTrio(document.querySelectorAll('.reassurance-card__icon'), SHIELD, TRUCK, RETURN);
    setTrio(document.querySelectorAll('.keng__ic'), SHIELD, TRUCK, RETURN);
    setTrio(document.querySelectorAll('.delivery-timeline__icon'), BAG, TRUCK, GIFT);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fixSectionIcons);}else{fixSectionIcons();}
})();

(function(){
  /* ---- Preuve sociale : pop-up commandes recentes avec image produit (donnees rafraichies manuellement) ---- */
  if(window.__kinboSP)return; window.__kinboSP=true;
  var ORDERS=JSON.parse('[{"name": "Fashon", "city": "Lille", "product": "Cloudtilt Remix - Black | Ivory", "ts": "2026-07-24T11:38:47Z", "img": "https://kinbomarket.fr/cdn/shop/files/110e32a6e3793339231a2b953232747956310f47.png?v=1783284777"}, {"name": "Oumou", "city": "Herblay-sur-Seine", "product": "Saucony PROGRID OMNI 9 OG Black Silver", "ts": "2026-07-24T00:29:25Z", "img": "https://kinbomarket.fr/cdn/shop/files/79219_233b0d41-e98e-4f53-9611-abd761efac52.jpg?v=1779361021"}]');
  if(!ORDERS.length)return;
  function ago(ts){var d=(Date.now()-new Date(ts).getTime())/1000;if(d<3600){var m=Math.max(2,Math.round(d/60));return 'il y a '+m+' min';}if(d<86400){var h=Math.max(1,Math.round(d/3600));return 'il y a '+h+' h';}var j=Math.max(1,Math.round(d/86400));return 'il y a '+j+' j';}
  var CHK='<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
  var el,idx=0,hideT;
  function build(){
    el=document.createElement('div');el.id='kinbo-sp';
    el.innerHTML='<span id="kinbo-sp__ic"><img id="kinbo-sp__img" alt="" loading="lazy"></span><div id="kinbo-sp__body"><div id="kinbo-sp__line1"></div><div id="kinbo-sp__meta"><span class="chk">'+CHK+'</span><span id="kinbo-sp__time"></span><span id="kinbo-sp__vf">Achat v\xe9rifi\xe9</span></div></div><button id="kinbo-sp__close" aria-label="Fermer">&#215;</button>';
    document.body.appendChild(el);
    el.querySelector('#kinbo-sp__close').addEventListener('click',function(e){e.stopPropagation();hide();});
  }
  function hide(){if(el)el.classList.remove('show');if(hideT){clearTimeout(hideT);hideT=null;}}
  function show(){
    if(!el)build();
    var o=ORDERS[idx%ORDERS.length];idx++;
    var im=el.querySelector('#kinbo-sp__img');
    if(o.img){im.src=o.img+(o.img.indexOf('?')>-1?'&':'?')+'width=160';im.style.display='block';}else{im.style.display='none';}
    el.querySelector('#kinbo-sp__line1').innerHTML='<b>'+o.name+'</b> de '+o.city+' vient de commander <span id="kinbo-sp__prod">'+o.product+'</span>';
    el.querySelector('#kinbo-sp__time').textContent=ago(o.ts);
    void el.offsetWidth;el.classList.add('show');
    hideT=setTimeout(hide,5000);
  }
  function start(){ setTimeout(function(){ show(); setInterval(show,120000); }, 6000); }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
})();

(function(){
  /* ---- Tiroir panier : 3e badge paiement + note promo, retrait ligne Shopify redondante ---- */
  if(window.__kinboProtect)return; window.__kinboProtect=true;
  var css='#cart-bump .cart-bump__pill{position:static;width:auto;height:auto;min-width:76px;background:#111;border-radius:999px;padding:9px 15px;display:inline-flex;align-items:center;justify-content:center;gap:5px;margin-left:auto;flex-shrink:0;box-shadow:none;transition:background .2s ease,transform .08s ease;}'
    +'#cart-bump .cart-bump__pill:active{transform:scale(.96);}'
    +'#cart-bump .cart-bump__pill-knob{display:none !important;}'
    +'#cart-bump .cart-bump__pill::after{content:"Ajouter";color:#fff;font-family:Inter,-apple-system,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.04em;text-transform:uppercase;white-space:nowrap;}'
    +'#cart-bump.cart-bump--added .cart-bump__pill{background:#1e9e54;}'
    +'#cart-bump.cart-bump--added .cart-bump__pill::after{content:"\\2713  Ajout\\00e9";}'
    +'.cart-drawer__scroll #cart-drawer-trust{margin:14px 6px 2px;padding:6px 6px 4px;border-top:1px solid #f0f0f0;}'
    +'.cart-drawer__scroll .cart-payment-icons{margin:16px 16px 4px !important;}'
    +'.cart-drawer__footer{padding-top:13px !important;}'
    +'#cart-bump{border-bottom:1px solid #eee;padding-bottom:11px;margin-bottom:11px;}'
    +'#cart-bump .cart-bump__head{gap:10px;}'
    +'#cart-bump .cart-bump__img{width:44px !important;height:44px !important;}'
    +'#cart-bump .cart-bump__txt{gap:2px !important;}'
    +'#cart-bump .cart-bump__label{font-size:9px !important;}'
    +'.cart-drawer__scroll #cart-bump{padding-left:16px !important;padding-right:16px !important;}'
    +'.shipping-bar{padding:11px 18px 12px !important;}'
    +'.shipping-bar__text{margin-bottom:9px !important;}'
    +'#kinbo-cart-count{margin-right:auto;margin-left:9px;font-size:11px;font-weight:500;color:#9a9a9a;letter-spacing:0.02em;align-self:center;}';
  function ensureStyle(){ if(document.getElementById('kinbo-protect-style'))return; var s=document.createElement('style'); s.id='kinbo-protect-style'; s.textContent=css; (document.head||document.documentElement).appendChild(s); }
  function money(c){ return (c/100).toFixed(2).replace('.',',')+' €'; }
  function updateTotals(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      var n=c.item_count, empty=(n===0);
      var title=document.querySelector('.cart-drawer__header-title');
      if(title){ var cnt=document.getElementById('kinbo-cart-count'); if(!cnt){ cnt=document.createElement('span'); cnt.id='kinbo-cart-count'; title.parentNode.insertBefore(cnt, title.nextSibling); } cnt.textContent=n>0?(n+' article'+(n>1?'s':'')):''; }
      ['cart-drawer-trust','kinbo-promo-note','kinbo-totals'].forEach(function(id){
        var e=document.getElementById(id); if(e) e.style.display=empty?'none':'';
      });
      var payS=document.querySelector('.cart-payment-icons'); if(payS) payS.style.display=empty?'none':'';
      var bump=document.getElementById('cart-bump'), foot=document.querySelector('.cart-drawer__footer'), scroll=document.querySelector('.cart-drawer__scroll');
      if(bump&&foot&&scroll){ if(n<=1){ if(bump.parentNode!==foot||foot.firstChild!==bump) foot.insertBefore(bump, foot.firstChild); } else { if(bump.parentNode!==scroll) scroll.appendChild(bump); } }
      if(empty)return;
      var sub=document.getElementById('kinbo-subtotal'); if(sub)sub.textContent=money(c.original_total_price);
      var row=document.getElementById('kinbo-eco-row'), ev=document.getElementById('kinbo-eco');
      if(c.total_discount>0){ if(row)row.style.display='flex'; if(ev)ev.textContent='−'+money(c.total_discount); }
      else if(row){ row.style.display='none'; }
    }).catch(function(){});
  }
  function inject(){
    ensureStyle();
    var foot=document.querySelector('.cart-drawer__footer');
    var scroll=document.querySelector('.cart-drawer__scroll');
    if(!foot||!scroll)return;
    foot.querySelectorAll('.cart-secure-line').forEach(function(sl){ sl.style.display='none'; });
    var trust=document.getElementById('cart-drawer-trust');
    if(trust && !trust.querySelector('[data-kinbo-pay]')){
      var b=document.createElement('div'); b.className='cart-drawer__trust-item'; b.setAttribute('data-kinbo-pay','');
      b.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg><span>Paiement sécurisé</span>';
      trust.insertBefore(b, trust.firstChild);
    }
    var oldProtect=document.getElementById('kinbo-protect');
    if(oldProtect&&oldProtect.parentNode){oldProtect.parentNode.removeChild(oldProtect);}
    var promo=document.getElementById('kinbo-promo-note');
    if(!promo){
      promo=document.createElement('div'); promo.id='kinbo-promo-note'; promo.className='cart-promo'; promo.style.margin='14px 16px 18px';
      promo.innerHTML='<div class="cart-promo__note"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg><span>Un code promo ? À saisir au moment du paiement.</span></div>';
    }
    /* Reassurance EPINGLEE dans le footer : sous le prix, juste au-dessus du bouton */
    var checkoutBtn=document.getElementById('kinbo-checkout-btn');
    var minMsg=document.getElementById('kinbo-min-msg');
    var anchor=(minMsg&&minMsg.parentNode===foot)?minMsg:checkoutBtn;
    if(anchor && anchor.parentNode===foot){
      if(trust) foot.insertBefore(trust, anchor);
      var pays=document.querySelector('.cart-payment-icons'); if(pays) foot.insertBefore(pays, anchor);
    }
    if(promo.parentNode!==scroll) scroll.appendChild(promo);
    var cont=foot.querySelector('.cart-drawer__continue'); if(cont && cont.parentNode!==scroll) scroll.appendChild(cont);
    updateTotals();
  }
  (function hookTot(){ var o=window.loadCart; if(typeof o==='function'&&!o.__kinboTotWrap){ var nf=function(){ var r=o.apply(this,arguments); setTimeout(inject,200); return r; }; nf.__kinboTotWrap=true; window.loadCart=nf; } })();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',inject); else inject();
})();
